import { RewardsTypes, RewardsAction, Reward } from '../types';

export function getListRewards(rewards: Reward[]): RewardsAction<{ rewards: Reward[] }> {
    return {
        type: RewardsTypes.GET_LIST_REWARDS,
        payload: { rewards },
    };
}

export function requestGetListRewards() {
    return {
        type: RewardsTypes.REQUEST_GET_LIST_REWARDS,
    };
}

export function saveReward(reward?: Reward): RewardsAction<{ reward?: Reward }> {
    return {
        type: RewardsTypes.SAVE_REWARD,
        payload: { reward },
    };
}

export function requestSaveReward(reward: Reward): RewardsAction<{ reward: Reward }> {
    return {
        type: RewardsTypes.REQUEST_SAVE_REWARD,
        payload: { reward },
    };
}
